import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Typography, Colors } from '@zapier/design-system';
import { FieldError } from 'react-aria-components';

const styles = css(Object.assign(Object.assign({}, Typography.SmallPrint1), { color: `var(--zds-status-error-stronger, ${Colors.StatusErrorStrongest})`, "&.compact": Object.assign({}, Typography.MinimalPrint1) }));
const ErrorMessage = (_a) => {
  var { children, isCompact } = _a, props = __rest(_a, ["children", "isCompact"]);
  return jsx(FieldError, Object.assign({}, props, {
    // Passing compact as a class name instead of a data attribute because FieldError does not spread data attributes. Only these props get passed: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-spectrum/s2/src/NumberField.tsx#L400-L406
    className: isCompact ? "compact" : void 0,
    css: styles,
    "data-compact": isCompact,
    "data-zds": true
  }), children);
};

export { ErrorMessage };
//# sourceMappingURL=ErrorMessage.es.js.map
